<div class="n-oldalfej">
  <div>
    <h2>{{ cim }}</h2>
    <span class="n-alcim">{{ alcim }}</span>
  </div>
  <div class="spacer"></div>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" *ngIf="nezet === 'nyugdijpenztar'"
              [disabled]="mnbFut" (click)="mnbFrissites()"
              title="A pénztárak listája az MNB közzétételi oldaláról (kozzetetelek.mnb.hu) – a meglévő adatokat nem írja felül">
    <ion-icon slot="start" [name]="mnbFut ? 'hourglass-outline' : 'cloud-download-outline'"></ion-icon>{{ mnbFut ? 'Frissítés…' : 'Frissítés az MNB-ről' }}</ion-button>
  <ion-button (click)="uj()" [disabled]="nezet === 'munkaszam' && !aktiv.ugyfelId"><ion-icon slot="start" name="add"></ion-icon>Új tétel</ion-button>
</div>

<div class="n-szuro-sor">
  <input type="search" [(ngModel)]="szuro" placeholder="Kód / megnevezés">
  <span class="spacer"></span>
  <span class="halvany">{{ szurt.length }} / {{ sorok.length }}</span>
</div>

<div class="ures" *ngIf="nezet === 'munkaszam' && !aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<!-- JOGCÍMEK -->
<div class="tabla-wrap" *ngIf="nezet === 'jogcim' && sorok.length">
  <table class="n-racs">
    <thead><tr><th>Kód</th><th>Megnevezés</th><th>Típus</th><th>SZJA-alap</th><th>Járulékalap</th><th>Szocho-alap</th><th>Megjegyzés</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let r of szurt" [class.rendezett]="!r.aktiv" (dblclick)="szerkeszt(r)">
        <td><b>{{ r.kod }}</b></td>
        <td>{{ r.nev }} <span class="cimke" *ngIf="r.rendszer" title="A számfejtés maga számolja – csak tájékoztató">automatikus</span>
          <span class="cimke" *ngIf="r.intezmeny === '*' && !r.rendszer" title="Beépített, közös jogcím">beépített</span></td>
        <td><span class="cimke" [class.zold]="r.tipus === 'jovedelem'" [class.sarga]="r.tipus === 'levonas'">{{ r.tipus === 'levonas' ? 'levonás' : 'jövedelem' }}</span></td>
        <td>{{ r.tipus === 'levonas' ? '—' : (r.szja ? 'igen' : 'nem') }}</td>
        <td>{{ r.tipus === 'levonas' ? '—' : (r.jarulek ? 'igen' : 'nem') }}</td>
        <td>{{ r.tipus === 'levonas' ? '—' : (r.szocho ? 'igen' : 'nem') }}</td>
        <td class="halvany">{{ r.megjegyzes || '' }}</td>
        <td class="ber-muv">
          <ng-container *ngIf="r.intezmeny !== '*'">
            <button type="button" class="kv-mini" (click)="szerkeszt(r)"><ion-icon name="create-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torol(r)"><ion-icon name="trash-outline"></ion-icon></button>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- MUNKASZÁMOK -->
<div class="tabla-wrap" *ngIf="nezet === 'munkaszam' && aktiv.ugyfelId">
  <table class="n-racs" *ngIf="sorok.length">
    <thead><tr><th>Kód</th><th>Megnevezés</th><th class="num">Jogviszony</th><th>Megjegyzés</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let r of szurt" [class.rendezett]="!r.aktiv" (dblclick)="szerkeszt(r)">
        <td><b>{{ r.kod }}</b></td><td>{{ r.nev }} <span class="cimke" *ngIf="!r.aktiv">inaktív</span></td>
        <td class="num">{{ r.jogviszony_db }}</td><td class="halvany">{{ r.megjegyzes || '' }}</td>
        <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkeszt(r)"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="kv-torol" (click)="torol(r)"><ion-icon name="trash-outline"></ion-icon></button></td>
      </tr>
    </tbody>
  </table>
  <div class="ures" *ngIf="!sorok.length"><ion-icon name="barcode-outline"></ion-icon>Még nincs munkaszám. A jogviszonyhoz rendelve a bérek munkaszámonként összesíthetők.</div>
</div>

<!-- NYUGDÍJPÉNZTÁRAK -->
<div class="tabla-wrap" *ngIf="nezet === 'nyugdijpenztar'">
  <table class="n-racs" *ngIf="sorok.length">
    <thead><tr><th>Név</th><th>Típus</th><th>Adószám</th><th>Bankszámla</th><th class="num">Tagok</th><th>Forrás</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let r of szurt" [class.rendezett]="!r.aktiv" (dblclick)="szerkeszt(r)">
        <td><b>{{ r.nev }}</b> <span class="cimke" *ngIf="!r.aktiv">inaktív</span></td>
        <td>{{ r.tipus === 'magan' ? 'Magánnyugdíjpénztár' : 'Önkéntes nyugdíjpénztár' }}</td>
        <td>{{ r.adoszam || '—' }}</td><td>{{ r.bankszamla || '—' }}</td><td class="num">{{ r.tag_db }}</td>
        <td><span class="cimke" *ngIf="r.forras === 'mnb'" [title]="'Az MNB listájáról, frissítve: ' + (r.mnb_frissitve | date:'yyyy.MM.dd HH:mm')">MNB</span>
          <span class="halvany" *ngIf="r.forras !== 'mnb'">kézi</span></td>
        <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkeszt(r)"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="kv-torol" (click)="torol(r)"><ion-icon name="trash-outline"></ion-icon></button></td>
      </tr>
    </tbody>
  </table>
  <div class="ures" *ngIf="!sorok.length"><ion-icon name="wallet-outline"></ion-icon>Még nincs nyugdíjpénztár – a listát az <b>MNB-ről</b> egy gombbal le lehet hozni.
    A tagdíj és a munkáltatói hozzájárulás a számfejtésben automatikusan megjelenik.</div>
</div>

<ion-modal #szerkModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? 'Szerkesztés' : 'Új' }} – {{ cim }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szerkModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <ng-container *ngIf="nezet === 'jogcim'">
          <label class="kv-mezo"><span>Kód *</span><input type="text" [(ngModel)]="szerk.kod" maxlength="10"></label>
          <label class="kv-mezo"><span>Megnevezés *</span><input type="text" [(ngModel)]="szerk.nev"></label>
          <label class="kv-mezo"><span>Típus</span><select [(ngModel)]="szerk.tipus"><option value="jovedelem">Jövedelem (a bruttó része)</option><option value="levonas">Levonás (a nettóból)</option></select></label>
          <div class="nk-kapcs" *ngIf="szerk.tipus === 'jovedelem'">
            <label><input type="checkbox" [(ngModel)]="szerk.szja"> SZJA-alap része</label>
            <label><input type="checkbox" [(ngModel)]="szerk.jarulek"> TB-járulék alapja</label>
            <label><input type="checkbox" [(ngModel)]="szerk.szocho"> Szocho (KIVA) alapja</label>
          </div>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes"></label>
        </ng-container>
        <ng-container *ngIf="nezet === 'munkaszam'">
          <label class="kv-mezo"><span>Kód *</span><input type="text" [(ngModel)]="szerk.kod" maxlength="20"></label>
          <label class="kv-mezo"><span>Megnevezés *</span><input type="text" [(ngModel)]="szerk.nev"></label>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes"></label>
        </ng-container>
        <ng-container *ngIf="nezet === 'nyugdijpenztar'">
          <label class="kv-mezo"><span>Név *</span><input type="text" [(ngModel)]="szerk.nev"></label>
          <label class="kv-mezo"><span>Típus</span><select [(ngModel)]="szerk.tipus"><option value="onkentes">Önkéntes nyugdíjpénztár</option><option value="magan">Magánnyugdíjpénztár</option></select></label>
          <label class="kv-mezo"><span>Adószám</span><input type="text" [(ngModel)]="szerk.adoszam"></label>
          <label class="kv-mezo"><span>Bankszámla</span><input type="text" [(ngModel)]="szerk.bankszamla"></label>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes"></label>
        </ng-container>
        <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="szerk.aktiv"> Aktív</label></div>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="ment()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>
